import {
  VuexModule,
  Module,
  Action,
  Mutation,
} from "vuex-module-decorators";
import ActionTypesApi from "@/api/actionTypes-api";
import dayjs from 'dayjs';
import { periodOptionToNumber, periodOptionToComboText, periodOptionToComboValue, timeChargedUnitOption, deepTrim } from "@/helpers/data";

@Module({ namespaced: true, name: "actionTypes" })
export default class ActionTypesModule extends VuexModule {
  public actionTypesCombo: any = []
  public actionTypes = []
  public actionTypeById: ActionsTypeDto[] = [];
  public isLoadingTable = true;


  @Action
  async addActionType(data: Record<string, any>) {
    const actionTypesApi = new ActionTypesApi()
    if(data.cost == undefined || data.cost == null || data.cost == '') {
      delete data.cost;
    }
    if(data.unit) {
      data.unit = data.unit.unit;
    }
    if(data.duration && typeof data.duration === 'object') {
      data.duration = data.duration.dur;
    }
    delete data.periodic_option_combo;
    delete data.reminder_option_combo;

    data = deepTrim(data);
    const response = await actionTypesApi.createActionType(data)
    return response;
  }

  @Action({ commit: 'setActionTypesCombo'})
  async getActionTypesCombo (): Promise<any[]> {
    const actionTypesApi = new ActionTypesApi()
    const actionTypesCombo = await actionTypesApi.actionTypesCombo();
    return actionTypesCombo
  }

  @Action({ commit: 'setActionTypes'})
  async getAllActionTypes (): Promise<any[]> {
    const actionTypesApi = new ActionTypesApi()
    const actionTypes = await actionTypesApi.getAllActionTypesCombo();
    return actionTypes
  }

  @Action({ commit: "setActionTypeById" })
  async getActionTypeById(actionTypeId: string): Promise<ActionsTypeDto[]> {
    const actionTypesApi = new ActionTypesApi();

    const actionType = await actionTypesApi.getActionTypeById(actionTypeId);

    return actionType;
  }

  @Action
  async editActionType(data: Record<string, any>) {
    const actionTypesApi = new ActionTypesApi()
    if(data.cost == undefined || data.cost == null || data.cost == '') {
      data.cost = 0;
    }
    if(data.unit) {
      data.unit = typeof data.unit === 'string' ? data.unit : data.unit.unit;
    }
    if(data.duration && typeof data.duration === 'object') {
      data.duration = data.duration.dur;
    }
    delete data.periodic_option_combo;
    delete data.reminder_option_combo;

    data = deepTrim(data);
    await actionTypesApi.updateActionType(data.id, data);
  }

  @Action
  async deleteActionType(data: Record<string, any>) {

    const actionTypesApi = new ActionTypesApi()
    await actionTypesApi.deleteActionType(data.id)
  }

  @Mutation
  public setActionTypesCombo (actionTypesCombo: any[]): void {
    actionTypesCombo.map(item => {
      item.next_task =  item.is_periodic ? dayjs().startOf('day').add(item.periodic_days, 'days').format('YYYY-MM-DD') : null
      item.reminder_option_value =  item.is_periodic ? periodOptionToNumber(item.reminder_option) : null
      item.reminder_option_combo =  item.is_periodic ? { text: periodOptionToComboText(item.reminder_option), period: periodOptionToComboValue(item.reminder_option) } : null
      item.unit = item.is_time_charged ? timeChargedUnitOption(item.unit) : null,
      item.unit_quantity = item.is_time_charged && !item.unit_quantity ? 1 : item.unit_quantity,
      item.unit_cost = item.is_time_charged && !item.unit_cost ? item.cost : item.unit_cost
    })
    this.actionTypesCombo = actionTypesCombo
  }

  @Mutation
  public setActionTypeById (actionTypeById: ActionsTypeDto[]): void {
    this.actionTypeById = actionTypeById;
  }

  @Mutation
  public setActionTypes (actionTypes: []): void {
    this.actionTypes = actionTypes;
  }

  @Mutation
  public setIsLoadingTable(isLoadingTable: boolean): void {
    this.isLoadingTable = isLoadingTable
  }
}
